import React from "react";

export default function BlockDeals({ blockData }) {
  return (
    <div>
      <div className="table-responsive stock-b-data">
        {blockData ? (
          <>
            {blockData.map((item, key) => (
              <div key={`block${key}`} className="row add-style">
                <div className="col-sm-6">{item.date}</div>
                <div className="col-sm-6 add-text-right">{item.ClientName}</div>
                <div className="col-sm-4">
                  <b>Qty:</b> {item.QuantityTraded}
                </div>
                <div className="col-sm-4">
                  <b>Price:</b> {item.TradePrice}
                </div>
                <div className="col-sm-4 add-text-right">
                  <b>
                    Action:
                    <span
                      style={{ color: item.action === "BUY" ? "green" : "red" }}
                    >
                      {item.action}
                    </span>
                  </b>
                </div>
              </div>
            ))}
          </>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
